import {Field} from 'formik';
import {FormikSelect} from '@flexinet/ui-components';

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="pipelineType"
                label="Pipeline Type"
                component={FormikSelect}
                data={[
                    {value: 'APPLICATION', label: 'Application'},
                    {value: 'API', label: 'API'},
                    {value: 'DATABASE', label: 'Database'},
                    {value: 'INFRASTRUCTURE', label: 'Infrastructure'},
                    {value: 'SERVICE', label: 'Service'},
                ]}
                clearable
                my="md"
            />
        </>
    );
};
